import { render } from "./update_idcard2.vue?vue&type=template&id=06231e3d&scoped=true"
import script from "./update_idcard2.vue?vue&type=script&lang=js"
export * from "./update_idcard2.vue?vue&type=script&lang=js"

import "./update_idcard2.vue?vue&type=style&index=0&id=06231e3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06231e3d"]])

export default __exports__